import { TreeNode } from '../route-builder';

export const CosmosModule = {
  segment: 'cosmos',
  title: '',
  navigationRoot: true,
  children: {
    CosmosSettingsComponent: {
      segment: '',
      icon: 'settings',
      title: 'cosmos.title'
    }
  }
} as const satisfies TreeNode;
